import React, {useState} from 'react';
import { gql, useMutation } from '@apollo/client';
import { Form, Field } from 'react-final-form'
import { isValidEmail } from "../validations"
import './NewsletterSubscriptionForm.css';

const ADD_NEWSLETTERSUBSCRIBER = gql`mutation createNewsletterSubscriber($email: String!){
  createNewsletterSubscriber(data: { email: $email }){
    id: documentId
  }
}
`;

const NewsletterSubscriptionForm = () => {
  const [registered, setRegistered] = useState(false)
  const [onSubmission, setOnSubmission] = useState(false)
  const [notificationMessage, setNotificationMessage] = useState("Successfully subscribed to the Visceral Sounds newsletter")
  const [subscriptionError, setSubscriptionError] = useState(null)
  const [AddNewsletterSubscriber] = useMutation(ADD_NEWSLETTERSUBSCRIBER);  
  
  const SubmitNewsletterSubscriptionForm = (payload) =>{
    setOnSubmission(true)
    setSubscriptionError("")
    AddNewsletterSubscriber({ variables: { email: payload.newsletterSubscription.email } }).then(function (value) {
      setOnSubmission(false)
      setRegistered(true)
      setNotificationMessage("Successfully subscribed to the Visceral Sounds newsletter")
    }, function (err) {
      setOnSubmission(false)
      if(err.message.includes("SQLITE_CONSTRAINT: UNIQUE constraint failed: newsletter_subscribers.email")){
        setOnSubmission(false)
        setRegistered(true)
        setNotificationMessage("This email was already subscribed to the newsletter, Thank you.")
      }else{
        setRegistered(false)
        setSubscriptionError("An error occured with your subscription, check your internet connection and try again. If the problem persists contact the administrator.")
      }
    });
    
  }

  return (
    <div style={{ marginBottom:"1em" }}>
    <Form
      onSubmit={SubmitNewsletterSubscriptionForm}
      //initialValues={initialState}
      validate={(values) => {
        let errors = {newsletterSubscription:{}}
        if(!values.newsletterSubscription || isValidEmail(values.newsletterSubscription.email)){
          errors.newsletterSubscription.email = "Invalid Email"
        }
        return errors
      }}

      render={({ handleSubmit, submitting, valid, submitSucceeded }) => (
        <div>
          <form onSubmit={handleSubmit} className={`${registered ? "hidden" : ""}`}>
            <span >Subscribe to our newsletter</span>
            <div style={{display: "flex",justifyContent: "flex-start"}}>
              <Field name={"newsletterSubscription[email]"}>
                {({ input, meta }) => (
                  <div style={{display:'inline-block'}}>
                    <input {...input} type="email" maxLength="254" placeholder="* EMAIL" className={`${meta.error && meta.touched ? "error" : ""}`} style={{display:'inline-block',margin:"unset", color:"white"}}/>
                    {meta.error && meta.touched && <small className="errorMessage">{meta.error}</small>}
                  </div>
                )}
              </Field>
              <button className={"formSubmit radius"} type="submit" disabled={submitting || !valid || registered} style={{padding:"0 1.5em 0 1.5em",margin:"unset"}}>Subscribe</button>
            </div>
          </form>
          { onSubmission ?
          <div style={{display: "flex", justifyContent: "center"}}><small style={{fontWeight:"bold"}}>Sending...</small></div>
          : null
        }
        { registered ?
          <div style={{display: "flex", justifyContent: "center"}}><small style={{color: "#69EBF1", fontWeight:"bold"}}>{notificationMessage}</small></div>
          : null
        }
        { subscriptionError ?
          <div style={{display: "flex", justifyContent: "center"}}><small className="errorMessage">{subscriptionError}</small></div>
          : null
        }
        </div>
      )}
    />
    </div>
  );
}

export default NewsletterSubscriptionForm;
